'use strict';

import {Cookie} from '../utils';



class Privacy extends HTMLElement{
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this._name = 'lookPrivacy';

    if (Cookie.get(this._name)) {
      this.classList.add('hidden');
      return;
    }

    this._button = this.querySelector('.closePrivacy');

    this._button.addEventListener('click', (e) => {
      e.preventDefault();

      Cookie.set(this._name, 'confirmed', {
        expires: 2147483647
      });

      this.classList.add('hidden');
    })
  }
  connectedCallback() {
  }
  disconnectedCallback() {
  }
}

window.customElements.define('privacy-view', Privacy);
